module.exports = __webpack_public_path__ + "img/13.76625d55.jpeg";